import { TFunction } from 'i18next';
import { icons } from '~/assets';
import { ReportItemEnum } from '~/utils/enum/common';
import { IReportItemDashboard } from '~/utils/interface/reports';

export const listDataReport = (t: TFunction): IReportItemDashboard[] => [
  {
    type: ReportItemEnum.INVENTORY_USAGE,
    icon: icons.reportIconInventoryUsage,
    title: t('reports_inventory_usage_title'),
    description: t('reports_inventory_usage_desc'),
  },
  {
    type: ReportItemEnum.OVERBOOKING_ITEMS,
    icon: icons.reportIconOverbookingItems,
    title: t('reports_overbooking_items_title'),
    description: t('reports_overbooking_items_desc'),
  },
  {
    type: ReportItemEnum.SUBRENTALS,
    icon: icons.reportIconSubrental,
    title: t('reports_subrentals_title'),
    description: t('reports_subrentals_desc'),
  },
  {
    type: ReportItemEnum.QUARANTINE,
    icon: icons.reportIconQuarantine,
    title: t('reports_quarantine_title'),
    description: t('reports_quarantine_desc'),
  },
  {
    type: ReportItemEnum.CLIENT_INCOME,
    icon: icons.reportIconClientIncome,
    title: t('reports_client_income_title'),
    description: t('reports_client_income_desc'),
  },
  {
    type: ReportItemEnum.REVENUE,
    icon: icons.reportIconRevenue,
    title: t('reports_revenue_title'),
    description: t('reports_revenue_desc'),
  },
  {
    type: ReportItemEnum.GEOGRAPHIC_REVENUE,
    icon: icons.reportIconGeographicRevenue,
    title: t('reports_geographic_revenue_title'),
    description: t('reports_geographic_revenue_desc'),
  },
  {
    type: ReportItemEnum.QUOTE_REVENUE,
    icon: icons.reportIconSubrental,
    title: t('reports_quote_revenue_title'),
    description: t('reports_quote_revenue_desc'),
  },
  {
    type: ReportItemEnum.ORDER_REVENUE,
    icon: icons.reportIconOrderRevenue,
    title: t('reports_order_revenue_title'),
    description: t('reports_order_revenue_desc'),
  },
  {
    type: ReportItemEnum.CANCELLATIONS,
    icon: icons.reportIconCancellations,
    title: t('reports_cancellations_title'),
    description: t('reports_cancellations_desc'),
  },
  // {
  //   type: ReportItemEnum.SCHEDULE,
  //   icon: icons.reportIconSchedule,
  //   title: t('reports_schedule_title'),
  //   description: t('reports_schedule_desc'),
  // },
  {
    type: ReportItemEnum.DELIVERY_PICKUP,
    icon: icons.reportIconDeliveryPickup,
    title: t('reports_delivery_pickup_title'),
    description: t('reports_delivery_pickup_desc'),
  },
  // {
  //   type: ReportItemEnum.FOREMAN_TASKS,
  //   icon: icons.reportIconForemanTasks,
  //   title: t('reports_foreman_tasks_title'),
  //   description: t('reports_foreman_tasks_desc'),
  // },
  {
    type: ReportItemEnum.FOREMAN_TASK_COMPLETION,
    icon: icons.reportIconForemanTaskCompletion,
    title: t('reports_foreman_task_completion_title'),
    description: t('reports_foreman_task_completion_desc'),
  },
  {
    type: ReportItemEnum.FUTURE_UTILIZATION,
    icon: icons.reportIconForemanTasks,
    title: t('reports_future_utilization_title'),
    description: t('reports_future_utilization_desc'),
  },
  {
    type: ReportItemEnum.MARKETING_REVENUE,
    icon: icons.reportIconMarketingRevenue,
    title: t('reports_marketing_revenue_title'),
    description: t('reports_marketing_revenue_desc'),
  },
  {
    type: ReportItemEnum.USER_TASKS,
    icon: icons.reportIconClientIncome,
    title: t('reports_user_tasks_title'),
    description: t('reports_user_tasks_desc'),
  },
  {
    type: ReportItemEnum.DISCOUNT_USAGE,
    icon: icons.reportIconOverbookingItems,
    title: t('reports_discount_usage_title'),
    description: t('reports_discount_usage_desc'),
  },
  {
    type: ReportItemEnum.JOB_COSTING,
    icon: icons.reportIconSubrental,
    title: t('reports_job_costing_title'),
    description: t('reports_job_costing_desc'),
  },
  {
    type: ReportItemEnum.FINANCIAL_ORDER,
    icon: icons.reportIconRevenue,
    title: t('reports_financial_order_title'),
    description: t('reports_financial_order_desc'),
  },
  {
    type: ReportItemEnum.TRANSACTION_SUMMARY,
    icon: icons.reportIconForemanTaskCompletion,
    title: t('reports_transaction_summary_title'),
    description: t('reports_transaction_summary_desc'),
  },
];
